import { Box, Card } from '@mui/material';
import React from 'react';
import { Table } from '../../../../../components';
import TelephoneColumns from '../../tables/TelephoneColumns';

const TelephoneSection = ({ telephones, isLoading }) => {
    return (
        <Card sx={{ paddingTop: '1rem', boxShadow: 'none' }}>
            <Box padding={'2.25rem 0'}>
                <Table
                    data={telephones}
                    columns={TelephoneColumns()}
                    isLoading={isLoading}
                    total={telephones.length}
                />
            </Box>
        </Card>
    );
};

export default TelephoneSection;
